import CustomElement from "./CustomElement";
import Swiper from "swiper/bundle";
import "swiper/css";

/**
 * A slot element for Swiper carousels
 * @typedef {Object} CustomElement~Carousel
 */
export default class ProductCarousel extends CustomElement {

	constructor() {

		super();

		this.carouselEl = this.querySelector(".swiper");
		this.slides = this.carouselEl.querySelectorAll(".swiper-slide");
		this.pagination = this.querySelector(".swiper-pagination");
		this.navigation = this.querySelector(".swiper-navigation");

		/**
		 * All the dataset attributes
		 * @param	{Object}	this.data
		 * @param	{string}	this.data
		 */
		this.data = this.carouselEl.dataset;
		this.anim = (this.data.animation) ? this.data.animation.toLowerCase() : "slide";

		if (this.data.thumbsSelector !== undefined) {

			this.thumbnailsElSelector = this.data.thumbsSelector;
			this.thumbs = document.querySelector(this.thumbnailsElSelector);

			if (this.thumbs) {

				this.thumbsType = this.thumbs.tagName;

				/** Non-swiper case for thumbs */
				if (this.thumbsType.toLowerCase() != "carousel") {

					if (this.pagination) {
						this.pagination = {
							el: this.thumbs,
							type: "bullets"
						}
					}

					this.thumbs = false;
				}

			} else {
				console.log("THIS PAGINATION UNDEFINED")
				this.pagination = undefined;
			}
		}
		this.slideIndex = this.carouselEl.querySelector(".slide-index")

		this.init();
	}


	init() {

		let desktopGutter = (this.data.gutter) ? parseInt(this.data.gutter) : 60;
		let mobileGutter = 0;

		this.options = {
			autoplay: (this.data.autoplay != undefined) ? {
				delay: parseFloat(this.data.timing)
			} : false,
			breakpoints: {
				769: {
					spaceBetween: (this.data.mobileOnly != undefined) ? 1000 : desktopGutter // we set an arbitrary value here to check against
				}
			},
			centeredSlides: (this.data.centered != undefined) ? true : false,
			effect: this.anim,
			height: (this.data.height) ? parseInt(this.data.height) : null,
			loop: (this.data.loops != undefined) ? true : false,
			loopedSlides: (this.data.loops != undefined) ? this.slides.length : null,
			pagination: (this.pagination != undefined) ? {
				bulletActiveClass: "active",
				bulletClass: "swiper-pagination-bullet",
				clickable: true,
				clickableClass: "swiper-pagination-clickable",
				currentClass: "swiper-pagination-current",
				el: (this.pagination.el) ? this.pagination.el : ".swiper-pagination",
				type: (this.pagination.type) ? this.pagination.type : "bullets"
			} : false,
			navigation: {
				nextEl: this.querySelector(".swiper-button-next"),
				prevEl: this.querySelector(".swiper-button-prev"),
			},
			slidesPerView: this.data.slidesperview || 'auto',
			spaceBetween: mobileGutter,
			speed: parseInt(this.data.speed),
			thumbs: this.thumbs,
			on: {
				breakpoint: (swiper, breakpointParams) => {

					if (breakpointParams.spaceBetween >= 1000) {
						swiper.destroy();
					}
				},
				click: (swiper) => {


				},
				paginationRender: (swiper, paginationEl) => {

				},
				init: (swiper) => {

					const colorAttr = swiper.slides[swiper.activeIndex]?.dataset.color;
					if (this.slideIndex) this.slideIndex.innerText = `1 of ${swiper.slides.length}`

					if (colorAttr) swiper.$el[0].style.backgroundColor = colorAttr;

					window.Zero.lazyLoad.update();
				},
				slideChange: (swiper) => {

					const colorAttr = swiper.slides[swiper.activeIndex].dataset.color;
					if (colorAttr) swiper.$el[0].style.backgroundColor = colorAttr
					if (this.slideIndex) this.slideIndex.innerText = `${swiper.activeIndex + 1} of ${swiper.slides.length}`
				}
			}
		};

		/** Effects */
		switch (this.data.effect) {

			case "crossfade":

				this.options.fadeEffect = {
					crossFade: true
				};

				break;

			default:

				break;
		}

		/** Set up our carousel */
		if (this.data.mobileOnly === undefined || window.Zero.windowWidth <= 768) {
			this.carousel = new Swiper(this.carouselEl, this.options);
		}
	}

	onResized(event) {

		if (this.data.mobileOnly === undefined) return;

		if (window.Zero.windowWidth <= 768) {

			if (!this.carousel || this.carousel.destroyed === true) {

				this.carousel = new Swiper(this.carouselEl, this.options);
			}
		}
	}
}
